<template>
    <div>
        <div class="warp">
            <el-input v-model="path" :disabled="true">
                <el-upload 
                    :action="baseUrl+action"
                    :show-file-list="false"
                    :accept="accept"
                    :before-upload="beforeUpload"
                    :http-request="myupload"
                    slot="suffix">
                    <!-- <div class="btn">文件上传</div> -->
                    <el-button class="btn" size="small" type="primary">文件上传</el-button>
                </el-upload>
            </el-input>
        </div>
    </div>
</template>

<script>
import {API} from "@/axios/config";
export default {
    props:{
        action:String,
        accept:String, //图片image/png,image/jpg,image/jpeg,image/bmp; 文件application/pdf ; xlx和xlsx application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        size:Number,//以m为基数
        value:String,//v-model的值
        // 是否需要验证上传图片尺寸
        isNeedLimit: { type: Boolean, default: false },
        scale: { type: Array, default: () => [] },
    },
    data(){
        return{
            baseUrl:API.UploadsService,//服务器
            // fileInfo:{},//文件数据
            sizeList: [48 / 8],
            temp: [],
            activeIdx: 0,
        }
    },
    computed:{
        path:{
            get: function () {
                return this.value;
            },
            set: function () {
                
            }
        }
    },
    methods:{
        //上传前
        beforeUpload:function(file){
            const that = this
            let limitSize=file.size / 1024 / 1024;
            if(limitSize > that.size){
                that.$message({
                    message: '文件大小不得超过'+that.size+'M',
                    type: 'error'
                });
                return false;
            }else{
              return true;
                // if(that.isNeedLimit){
                //   that.imageRatio(file,  that.isNeedLimit ? 1 : void 0).then(q => {
                //     // debugger
                //     // if (that.needFileInfo) {
                //     //   that.getFileInfo(file)
                //     //     .then(fileInfo => that.initFile(fileIdx, fileInfo))
                //     //     .then(() => that.upload(file, fileIdx))
                //     // } else {
                //     //   that.initFile(fileIdx)
                //     //   that.upload(file, fileIdx)
                //     // }
                //   }).catch(err => {
                //     console.log(err)
                //   })
                // }
                // else return true;
            }
        },
        //自定义上传
        myupload:function(content){
            let formData = new FormData();
            formData.append("file",content.file);
            
            this.$axiosz.post(content.action,formData).then((r)=>{
                if(r.code==200){
                    this.path=r.data.filePath;
                    this.$emit('input',r.data.filePath);
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                }else{
                    this.$alert(r.msg);
                }
            })
        },
        // 验证图片比例
    imageRatio(raw, param) {
      const that = this
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(raw)
        reader.onload = () => {
          const img = new Image()
          img.src = reader.result
          img.onload = () => {
            const ratio = img.naturalWidth / img.naturalHeight
            if (that.isNeedLimit) {
              if (!that.sizeList.includes(ratio)) {
                const fileIdx = that.temp.length
                that.temp.push(fileIdx)
                if (that.activeIdx === -1) that.activeIdx = fileIdx
                resolve(false)
              } else {
                
                resolve(true)
              }
            } else {
              resolve(true)
            }
          }
        }
      })
    },
    },
    mounted(){

    }
}
</script>

<style lang="scss" scoped>
.warp{
	/deep/ .el-input__inner{
		padding-right: 70px;
	}
    /deep/ .el-input__suffix{
        right: 0;
        .el-input__suffix-inner{
            height: 100%; 
            div{
                height: 100%;
            }
            .el-upload{
                height: 100%;
            }
        }
    }
    .btn{
        width:67px;
        background:rgba(239,239,239,0.5);
        border:1px solid rgba(229,229,229,1);
        font-size:12px;
        font-weight:400;
        text-align: center;
        color:rgba(177,177,177,1);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>